import { Flex, Text, Textarea, useToast } from '@chakra-ui/react'
import { Button } from '../../../components/Button'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { onUpdateLigacao } from './functions/updateObservacoes'

const schema = z.object({
    numero_nota: z.string(),
    validar_ligacao: z.string().nonempty(),
})

export function ValidarLigacao({ nunota, dadosPedido }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            numero_nota: nunota,
            validar_ligacao: dadosPedido?.validar_ligacao,
        },
    })

    const queryClient = useQueryClient()

    const toast = useToast({
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const { mutateAsync, isLoading: loading } = useMutation({
        mutationFn: onUpdateLigacao,
        onSuccess: () => {
            queryClient.setQueryData(['infoPedido', { numeroNota: nunota }], (oldData) => {
                return {
                    ...oldData,
                    dados_pedido: {
                        ...oldData.dados_pedido,
                        ligacao_validada: true,
                    },
                }
            })

            toast({
                title: 'Ligação validada com sucesso',
                status: 'success',
            })
        },
        onError: (error) => {
            toast({
                title: 'Erro ao atualizar Ligação',
                description: error.message,
                status: 'error',
            })
        },
    })

    async function onSubmit(data) {
        await mutateAsync(data)
    }

    return (
        <Flex alignItems="center" gap={2} w="full">
            <Text color="#555" fontWeight="bold" whiteSpace="nowrap" maxW="190px" w="full">
                4 - VALIDAR LIGAÇÃO:
            </Text>{' '}
            <Flex w="full" justifyContent="start" alignItems="center" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
                <input type="hidden" {...register('numero_nota')} value={nunota} />
                <Textarea
                    borderRadius="0"
                    bgColor={'#F5F5F5'}
                    _hover={{ borderColor: '#F5F5F5' }}
                    _focus={{ borderColor: '#F5F5F5' }}
                    borderColor={'#F5F5F5'}
                    my={2}
                    maxW="600px"
                    placeholder="Validar ligação"
                    resize="none"
                    // disabled={dadosPedido.aprovacao_pedido}
                    rows={1}
                    {...register('validar_ligacao')}
                    isInvalid={!!errors.validar_ligacao}
                    errorBorderColor="red.300"
                />
                <Button type="submit" isLoading={loading} loadingText="Atualizando...">
                    Atualizar validar ligação
                </Button>
            </Flex>
        </Flex>
    )
}
